import ServiceEditTemplate from "components/templates/ServiceEditTemplate/ServiceEditTemplate";

const ServiceEditPage = () => <ServiceEditTemplate />;

export default ServiceEditPage;
